// extracted by mini-css-extract-plugin
module.exports = {"UserMenu":"UserMenu--3CzY_","Icon":"Icon--3r6u7"};